// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + chunkId + "--" + {"2297":"3157bfe","3318":"e0ebcd7","8816":"3af87bc"}[chunkId] + ".js";
};